import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { departmentAuthApi } from '../../services/api';

const DepartmentLogin = () => {
  const navigate = useNavigate();
  const { companySlug } = useParams();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const res = await departmentAuthApi.login(values);
      if (res.success) {
        localStorage.setItem('department_token', res.data.token);
        localStorage.setItem('department_admin', JSON.stringify(res.data.departmentAdmin));
        message.success('登录成功');
        navigate(`/${companySlug}/department`);
      }
    } catch (error) {
      message.error(error.response?.data?.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f8f6f3 0%, #f0ece5 100%)',
      padding: 16
    }}>
      <div style={{
        width: '100%',
        maxWidth: 400,
        padding: 32,
        background: '#fff',
        borderRadius: 12,
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <h1 style={{ fontSize: 22, color: '#8B7355', marginBottom: 6 }}>部门登录</h1>
          <p style={{ color: '#999', fontSize: 14 }}>请输入您的账户信息</p>
        </div>

        <Form layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input size="large" placeholder="用户名" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password size="large" placeholder="密码" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              block
              loading={loading}
              style={{ background: '#8B7355' }}
            >
              登录
            </Button>
          </Form.Item>

          <div style={{ textAlign: 'center', fontSize: 13 }}>
            <a href={`/${companySlug}/admin/login`} style={{ color: '#8B7355', marginRight: 16 }}>管理员登录</a>
            <a href={`/${companySlug}/store/login`} style={{ color: '#8B7355' }}>门店登录</a>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default DepartmentLogin;
